"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.baseStyle = void 0;
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
var parts = ['control', 'label'];
var baseStyle = exports.baseStyle = {
  container: {
    alignItems: 'start'
  },
  control: {
    borderRadius: '50%',
    borderWidth: '1px',
    borderColor: 'gray.dark',
    backgroundColor: 'white',
    color: 'white',
    minWidth: 5,
    minHeight: 5,
    marginTop: 1,
    transition: 'all 150ms ease',
    _before: {
      content: '""',
      display: 'inline-block',
      position: 'relative',
      width: '0px',
      height: '0px',
      opacity: '0',
      borderRadius: '50%',
      background: 'currentcolor',
      transition: 'all 150ms ease-in',
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.25))"
    },
    _checked: {
      borderColor: 'primary.default',
      color: 'white',
      backgroundColor: 'primary.default',
      _before: {
        width: 2,
        height: 2,
        opacity: '1'
      }
    },
    _focus: {
      boxShadow: 'outline'
    },
    _disabled: {
      borderColor: 'gray.200',
      _checked: {
        backgroundColor: 'gray.200'
      }
    }
  },
  label: {
    fontSize: 'base',
    color: 'black',
    marginLeft: 3,
    _disabled: {
      color: 'gray.200'
    }
  }
};
var sizes = {
  sm: {
    control: {
      minWidth: 4,
      minHeight: 4,
      _checked: {
        _before: {
          width: 1.5,
          height: 1.5
        }
      }
    }
  },
  md: {
    control: {
      minWidth: 5,
      minHeight: 5,
      _checked: {
        _before: {
          width: 2,
          height: 2
        }
      }
    },
    label: {
      fontSize: 'base'
    }
  },
  lg: {
    control: {
      minWidth: 6,
      minHeight: 6,
      _checked: {
        _before: {
          width: 2.5,
          height: 2.5
        }
      }
    },
    label: {
      fontSize: 'md'
    }
  }
};
var defaultProps = {
  size: sizes.md
};
var _default = exports["default"] = (0, _merge["default"])(_theme["default"].components.Radio, {
  parts: parts,
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: defaultProps
});